<template>
  <div>
    <b-modal id="VideoPlayer"
      ref="video-modal"
      v-model="modalShow"
      @shown="modalshown($event)"
      @hidden="modalClose($event)"
      hide-footer>
      <video-player class="video-player-box"
        id="videoPlayer"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
        @ended="onPlayerEnded($event)"
        @waiting="onPlayerWaiting($event)"
        @playing="onPlayerPlaying($event)"
        @loadeddata="onPlayerLoadeddata($event)"
        @timeupdate="onPlayerTimeupdate($event)"
        @canplay="onPlayerCanplay($event)"
        @canplaythrough="onPlayerCanplaythrough($event)"
        @statechanged="playerStateChanged($event)"
        @ready="playerReady">
      </video-player>
    </b-modal>
  </div>
</template>
<script>
  import { courseMixin } from './_Mixins'
  import utils from '../utils'

  import $ from 'jquery'
  import videojs from 'video.js'
  // import '@videojs/http-streaming'
  import 'videojs-contrib-hls'
  // import 'videojs-contrib-media-sources'

  window.videojs = videojs

  let lang = require('video.js/dist/lang/zh-TW.json')
  videojs.addLanguage('zh-TW', lang)
  videojs.addLanguage('zh', lang)

  //console.log('VideoJS.vue', videojs)
  // TODO: re tune VideoJS for Vue
  // https://github.com/surmon-china/vue-video-player
  // Skin Generator :
  // https://www.scriptsmashup.com/Video_Skin_Generator/Videojs/videojs-skin-generator.html

  export default {
    data() {
      return {
        customOptions: null,
        playerOptions: {
          // videojs options
          muted: false,
          html5: {
            nativeAudioTracks: false,
            nativeVideoTracks: false,
            hls: { withCredentials: false }
          },
          overrideNative: true,
          preload: 'auto',
          fluid: true,
          language: 'zh-TW',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [],
        },
        subtitleOptions: null,
        modalShow: false,
      }
    },

    mounted() {
      this.$on('bv::modal::hide', function() {
        console.log('VideoJS.vue', 'bv::modal::hide')
      })
    },

    mixins: [ courseMixin ],

    computed: {
      $modal() {
        // if (!this.$bvModal['visible']) {
        //   this.$bvModal['visible'] = false
        // }
        // return this.$bvModal
        return this.$refs['video-modal']
      },

      isModalVisible() {
        return this.modalShow
        // if (!this.$modal['visible']) {
        //   return false
        // }

        // console.log('VideoJS.vue', 'computed isModalVisible', this.$modal['visible'])
        // return this.$modal['visible']
      },

      player() {
        return this.$refs.videoPlayer.player
      },

      playerDom() {
        return $('#VideoPlayer video')
      },

      player_options() {
        let _options = this.playerOptions

        if (this.customOptions && this.customOptions != null) {
          _options = this.customOptions
        }
        _options['techOrder'] = ['html5']

        return _options
      },

    },

    methods: {
      showPlayer() {
        console.log('VideoJS.vue', 'showPlayer()', 'this.isModalVisible', this.isModalVisible)

        if (this.isModalVisible) return

        // console.log('VideoJS.vue', 'showPlayer()', this.$modal.show)

        // this.$modal.show('VideoPlayer')
        // this.$modal.show()
        this.modalShow = true
        // this.player.autoplay('play')

        let _this = this

        setTimeout(function() {
          // console.log('VideoJS.vue', 'methods.showPlayer()', _this.$modal)

          var $player = $('#videoPlayer video[src]')
          // console.log('VideoJS.vue', 'methods.showPlayer()', '$player', _this.player, $player)

          $player.attr({ 'crossorigin': 'anonymous' })

          console.log('VideoJS.vue', '_this.subtitleOptions : ', _this.subtitleOptions)

          if (_this.subtitleOptions && _this.subtitleOptions != null) {
            let addSubtitle = function(subtitleOption) {
              var $track = $(document.createElement('track'))
              $track.attr({
                //'kind': _this.subtitleOptions.kind,
                'kind': subtitleOption.kind,
                'src': subtitleOption.src,
                'srclang': subtitleOption.srclang,
                'label': subtitleOption.label,
                'default': true,
              })
              $player.append($track)
            };

            if (Array.isArray(_this.subtitleOptions)) {
              for (let i = 0; i < _this.subtitleOptions; i++) {
                var subtitleOption = _this.subtitleOptions[i]
                addSubtitle(subtitleOption)
              }
            }
            else {
              addSubtitle(_this.subtitleOptions)
            }
          }

          //_this.player.autoplay('play')
          _this.player.play()
        }, 500)
      },

      closePlayer() {
        console.log('VideoJS.vue', 'methods.closePlayer()')

        this.player.pause()
        // this.$modal.hide('VideoPlayer')
        this.$modal.hide()
      },

      modalshown() {
        console.log('VideoJS.vue', 'methods.modalshown()')

        this.$modal['visible'] = true
      },

      modalClose() {
        console.log('VideoJS.vue', 'on Modal Close Event')

        this.player.pause()
      },

      play(src, options, subtitleOptions) {
        let _this = this
        // if (options == undefined || options == null) {
        //   options = {
        //     // videojs options
        //     muted: false,
        //     fluid: true,
        //     language: 'zh-TW',
        //     playbackRates: [0.7, 1.0, 1.5, 2.0],
        //     sources: [],
        //   }
        // }

        // test LDE/ch01/1-1.mp4 on ios
        if (utils.isPromise(src)){
          console.log('VideoJS.vue', 'play', 'isPromise')
          src.then(value => {
            _this.play(value, options, subtitleOptions)
          })
          return
        }

        if (src.endsWith('LDE/ch01/1-1.mp4')) {
          src = src.replace('LDE/ch01/1-1.mp4', 'LDE/ch01/ts/1-1.m3u8')
        }

        console.log('VideoJS.vue', 'options', options)

        var updatePlaySource = function(src, options, subtitleOptions) {
          // console.log('VideoJS.vue', 'play', src)

          if (options && options != null) {
            _this.customOptions == options

            // console.log('VideoJS.vue', 'play', 'updatePlaySource', '>>> videojs_player.ready()', '>>>>>> _this.playerOptions', _this.playerOptions)
          }

          // return
          if (!src || src == '') {
            return
          }

          let videojs_player = videojs('videoPlayer', _this.player_options)

          videojs_player.ready(function() {
            console.log('VideoJS.vue', 'play', 'updatePlaySource', '>>> videojs_player.ready()', '>>>>>> src, options, subtitleOptions', src, options, subtitleOptions, _this.customOptions)

            if (subtitleOptions && subtitleOptions != null) {
              //videojs_player.addRemoteTextTrack(subtitleOptions, true)
              _this.subtitleOptions = subtitleOptions
              //console.log('VideoJS.vue', 'play', 'updatePlaySource', '>>> videojs_player.ready()', '>>>>>> addRemoteTextTrack')
            }

            console.log('VideoJS.vue', 'play', 'updatePlaySource', '>>> src', src)

            let _type = 'video/mp4'
            if (src.endsWith('.m3u8')) {
              _type = 'application/x-mpegURL'
            }

            // _this.playerOptions.sources = [{
            _this.player_options.sources = [{
              withCredentials: false,
              type: _type,
              src: src,
            }]
          })
        }

        if (utils.isPromise(src) || utils.isPromise(options)) {
          let checkAndRun = function(_src, _options) {
            if (utils.isPromise(_src)) {
              _src.then((__src) => {
                checkAndRun(__src, _options)
              })
              return
            }
            if (utils.isPromise(_options)) {
              _options.then((__options) => {
                checkAndRun(_src, __options)
              })
              return
            }

            updatePlaySource(_src, _options, subtitleOptions);
            return
          }

          checkAndRun(src, options)
        }
        else {
          updatePlaySource(src, options, subtitleOptions)
        }

        // if (!src.startsWith('//')) {
        //   src = `//media-dlc.sce.pccu.edu.tw/deep${src}`
        // }

        // this.playerOptions.sources = [{
        //   type: 'video/mp4',
        //   src: src,
        // }]
        // this.video_src = src
        // console.log('VideoJS.vue', 'play', this.$bvModal)
        // return

        // let $modal = this.$bvModal
        // var options = {}

        // var player = videojs('my-player',
        //   options,
        //   function onPlayerReady() {
        //     $modal.show('VideoPlayer')

        //     videojs.log('Your player is ready!');

        //     // In this context, `this` is the player that was created by Video.js.
        //     this.play();

        //     // How about an event listener?7
        //     this.on('ended', function () {
        //       videojs.log('Awww...over so soon?!');
        //     });
        //   });
      },

      // listen event
      onPlayerPlay(player) {
        this.$modal['visible'] = true

        console.log('VideoJS.vue', 'player play!', player)
      },
      onPlayerPause(player) {
        console.log('VideoJS.vue', 'player pause!', player)
      },
      onPlayerEnded(player) {
        console.log('VideoJS.vue', 'player ended', player)
        this.closePlayer()
      },
      onPlayerWaiting(player) {
        console.log('VideoJS.vue', 'player waiting', player)
      },
      onPlayerPlaying(player) {
        // console.log('VideoJS.vue', 'player playing', player)
      },

      // ...player event
      onPlayerLoadeddata(player) {
        // console.log('VideoJS.vue', 'player data loaded', player)
        // this.showPlayer()
      },
      onPlayerTimeupdate(player) {
        // console.log('VideoJS.vue', 'player time update', player)
      },
      onPlayerCanplay(player) {
        console.log('VideoJS.vue', 'player can play', player)

        let _this = this

        setTimeout(() => {
          _this.showPlayer()
        }, 100)
      },
      onPlayerCanplaythrough(player) {
        // console.log('VideoJS.vue', 'player can play through', player)
      },

      // or listen state event
      playerStateChanged(playerCurrentState) {
        // console.log('VideoJS.vue', 'player current update state', playerCurrentState)
      },

      // player is ready
      playerReady($event) {
        // console.log('VideoJS.vue', 'the player is ready', $event)
        // you can use it to do something...
        // player.[methods]
        // if (Array.isArray($event.options.sources) == false) return
        // if ($event.options.sources.length > 0) {
        //   this.showPlayer()
        // }
      }
    },

    watch: {
      isModalVisible: (visible) => {
        // console.log('VideoJS.vue', 'watch isModalVisible', visible)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/VideoJS.vue